export default "./dist/stdassets/images/icons/select-radius.png";